// extracted by mini-css-extract-plugin
module.exports = {"root":"VerticalTable_root__W6Yy6"};